import Headline from '../../../commons/src/components/headline'
import Paragraph from '../../../commons/src/components/paragraph'
import Container from '../components/container'
import PageContentLayout from '../components/page-content-layout'
import PageHeader from '../components/page-content-layout/PageHeader'

import PagePartial from './page-partial'

const NotFoundPage = () => (
  <PagePartial>
    <PageContentLayout
      header={<PageHeader headline={<Headline size="l" label="Page not found" />} />}
    >
      <Container>
        <Paragraph>We looked everywhere but couldn&#39;t find the page you requested.</Paragraph>
      </Container>
    </PageContentLayout>
  </PagePartial>
)

export default NotFoundPage
